import { FeatureFlag } from '@mews-commander/enums';
import { EnterprisePaths } from '@mews-commander/ui';
import { useFeatureFlag } from '@mews/framework';
import { useGetAccountingConfigurationReceivableTrackingEnabled } from '../../../../payment/queries';

export const useNewLedgersSidebarLinkEnabled = (isCurrentProfilePlatformAdmin: boolean) => {
    const {
        data: receivableTrackingEnabled = false,
        isFetching: isReceivableTrackingFetching,
        isError: isReceivableTrackingError,
    } = useGetAccountingConfigurationReceivableTrackingEnabled(!isCurrentProfilePlatformAdmin);

    const cityLedgerEnabled = receivableTrackingEnabled && !isReceivableTrackingError && !isReceivableTrackingFetching;
    const depositLedgerEnabled = useFeatureFlag(FeatureFlag.newDepositLedger);
    const guestLedgerEnabled = useFeatureFlag(FeatureFlag.mewsGuestLedger);
    const goodDataLedgersEnabled = useFeatureFlag(FeatureFlag.newFinanceLedgersEnabled);

    return cityLedgerEnabled || depositLedgerEnabled || guestLedgerEnabled || goodDataLedgersEnabled;
};

export const useGetNewFinanceLedgersPath = (isCurrentProfilePlatformAdmin: boolean) => {
    const {
        data: receivableTrackingEnabled = false,
        isFetching: isReceivableTrackingFetching,
        isError: isReceivableTrackingError,
    } = useGetAccountingConfigurationReceivableTrackingEnabled(!isCurrentProfilePlatformAdmin);
    const cityLedgerEnabled = receivableTrackingEnabled && !isReceivableTrackingError && !isReceivableTrackingFetching;
    const depositLedgerEnabled = useFeatureFlag(FeatureFlag.newDepositLedger);
    const guestLedgerEnabled = useFeatureFlag(FeatureFlag.mewsGuestLedger);
    const goodDataLedgersEnabled = useFeatureFlag(FeatureFlag.newFinanceLedgersEnabled);

    if (goodDataLedgersEnabled || depositLedgerEnabled) {
        return 'Finance/Ledgers/Deposit' satisfies EnterprisePaths;
    }

    if (guestLedgerEnabled) {
        return 'Finance/Ledgers/Guest' satisfies EnterprisePaths;
    }

    if (cityLedgerEnabled) {
        return 'Finance/Ledgers/City' satisfies EnterprisePaths;
    }

    return 'Finance/Ledgers' satisfies EnterprisePaths;
};
